/**
 * Calculador de Frete para Shopify
 * Integração com API do Melhor Envio
 * 
 * Para usar, inclua este script na sua página de produto e chame:
 * CalculadorFrete.init({
 *   apiUrl: 'https://sua-api.com',
 *   fromPostalCode: '01001000',
 *   containerId: 'calculador-frete'
 * });
 */


// Funções auxiliares para calcular data de entrega
function adicionarDiasUteis(data, dias) {
    let resultado = new Date(data);
    while (dias > 0) {
        resultado.setDate(resultado.getDate() + 1);
        const dia = resultado.getDay();
        if (dia !== 0 && dia !== 6) dias--; // pula domingo e sábado
    }
    return resultado;
}

function formatarDataEntrega(data) {
    const diasSemana = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
    const diaSemana = diasSemana[data.getDay()];
    const dia = data.getDate();
    const mes = meses[data.getMonth()];
    return `Chega até ${diaSemana}, ${dia} de ${mes}`;
}


class CalculadorFrete {
    constructor(config) {
        this.config = {
            apiUrl: config.apiUrl || 'https://api-frete-aurea-11d6c1c299c8.herokuapp.com',
            fromPostalCode: config.fromPostalCode || '08131220',
            containerId: config.containerId || 'calculador-frete',
            productData: config.productData || null,
            ...config
        };
        
        this.container = null;
        this.isLoading = false;
        this.lastResults = null;
    }
    
    static init(config) {
        const calculator = new CalculadorFrete(config);
        calculator.render();
        return calculator;
    }
    
    render() {
        this.container = document.getElementById(this.config.containerId);
        if (!this.container) {
            console.error(`Container ${this.config.containerId} não encontrado`);
            return;
        }
        
        this.container.innerHTML = this.getHTML();
        this.attachEvents();
    }
    
    getHTML() {
        return `
          
                
                <div class="calculador-frete__form">
                    <div class="calculador-frete__input-group">
                        <label for="cep-destino" class="calculador-frete__label">CEP de destino:</label>
                        <div class="calculador-frete__input-wrapper">
                            <input 
                                type="text" 
                                id="cep-destino" 
                                class="calculador-frete__input"
                                placeholder="00000-000"
                                maxlength="9"
                            />
                            <button 
                                type="button" 
                                class="calculador-frete__button"
                                onclick="this.closest('.calculador-frete').calculator.calculate()"
                            >
                                Calcular Frete
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="calculador-frete__results" id="frete-results" style="display: none;">
                    <!-- Resultados serão inseridos aqui -->
                </div>
                
                <div class="calculador-frete__loading" id="frete-loading" style="display: none;">
                    <div class="calculador-frete__spinner"></div>
                    <span>Calculando frete...</span>
                </div>
                
                <div class="calculador-frete__error" id="frete-error" style="display: none;">
                    <!-- Erros serão exibidos aqui -->
                </div>
            </div>
        `;
    }
    
    attachEvents() {
        this.container.calculator = this;

    const cepInput = this.container.querySelector('#cep-destino');
    const calculateButton = this.container.querySelector('.calculador-frete__button');

    // Evento ENTER
    cepInput.addEventListener('input', this.formatCEP.bind(this));
    cepInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            this.calculate();
        }
    });

    // Clique no botão
    if (calculateButton) {
        calculateButton.addEventListener('click', () => {
            this.calculate();
        });
    }

    // Auto calcular ao colar CEP
    cepInput.addEventListener('paste', () => {
        setTimeout(() => {
            if (this.isValidCEP(cepInput.value)) {
                this.calculate();
            }
        }, 100);
    });
}
    formatCEP(event) {
        let value = event.target.value.replace(/\D/g, '');
        if (value.length > 5) {
            value = value.replace(/^(\d{5})(\d)/, '$1-$2');
        }
        event.target.value = value;
    }
    
    isValidCEP(cep) {
        const cleanCEP = cep.replace(/\D/g, '');
        return cleanCEP.length === 8;
    }
    
async calculate() {
    const cepInput = this.container.querySelector('#cep-destino');
    const cep = cepInput.value.replace(/\D/g, '');
    
    if (!this.isValidCEP(cep)) {
        this.showError('Por favor, insira um CEP válido');
        return;
    }
    
    this.showLoading(true);
    this.hideError();
    this.hideResults();
    
    try {
        const productData = this.getProductData();
        const response = await this.callAPI(cep, productData);

        this.showResults(response);
        this.lastResults = response;
    } catch (error) {
        console.error('Erro ao calcular frete:', error);
        this.showError('Erro de conexão. Tente novamente.');
    } finally {
        this.showLoading(false);
    }
}

    
    getProductData() {
        if (this.config.productData) {
            return this.config.productData;
        }
        
        const productData = {
            id: 'default',
            price: 0,
            weight: 0.3, 
            width: 10,   
            height: 5,
            length: 15,
            quantity: 1
        };
        
        const priceElement = document.querySelector('.price, .product-price, [data-price]');
        if (priceElement) {
            const priceText = priceElement.textContent || priceElement.getAttribute('data-price') || '0';
            const price = parseFloat(priceText.replace(/[^\d,]/g, '').replace(',', '.'));
            if (!isNaN(price)) {
                productData.price = price;
            }
        }
        
        const weightElement = document.querySelector('[data-weight]');
        if (weightElement) {
            const weight = parseFloat(weightElement.getAttribute('data-weight'));
            if (!isNaN(weight)) {
                productData.weight = weight > 50 ? weight / 1000 : weight; 
            }
        }
        
        ['width', 'height', 'length'].forEach(dimension => {
            const element = document.querySelector(`[data-${dimension}]`);
            if (element) {
                const value = parseFloat(element.getAttribute(`data-${dimension}`));
                if (!isNaN(value)) {
                    productData[dimension] = value;
                }
            }
        });
        
        return productData;
    }
    
async callAPI(cep, productData) {
    const payload = {
        to: cep,
        product: productData
    };
    
    const response = await fetch(`${this.config.apiUrl}/frete`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.details || 'Erro desconhecido da API');
    }

    return await response.json();
}


  
    showResults(shippingOptions) {
        const resultsContainer = this.container.querySelector('#frete-results');
        
        // 1. Filtrar e selecionar as transportadoras e modalidades específicas
        let filteredOptions = [];

        // Loggi: Apenas Express
        const loggiExpress = shippingOptions.find(option => 
            option.company && option.company.name === 'Loggi' && option.name.includes('Express')
        );
        if (loggiExpress) {
            filteredOptions.push(loggiExpress);
        }

        // Jadlog: .com ou Package (o mais barato)
        const jadlogOptions = shippingOptions.filter(option => 
            option.company && option.company.name === 'Jadlog' && 
            (option.name.includes('.com') || option.name.includes('Package'))
        );
        if (jadlogOptions.length > 0) {
            const cheapestJadlog = jadlogOptions.reduce((prev, current) => 
                (prev.price < current.price) ? prev : current
            );
            filteredOptions.push(cheapestJadlog);
        }

        // Correios: Mini Envios e Sedex
        const correiosMiniEnvios = shippingOptions.find(option => 
            option.company && option.company.name === 'Correios' && option.name.toLowerCase().includes('Mini Envios')
        );
        if (correiosMiniEnvios) {
            filteredOptions.push(correiosMiniEnvios);
        }
      const correiosSedex = shippingOptions.find(option => 
    option.company && option.company.name === 'Correios' && option.name.toLowerCase().includes('sedex')
);
        if (correiosSedex) {
            filteredOptions.push(correiosSedex);
        }

        // Ordenar as opções filtradas do mais barato para o mais caro
        filteredOptions.sort((a, b) => a.price - b.price);

        // 2. Adicionar fretes informativos (mantidos)
        const productPrice = this.config.productData ? this.config.productData.price : 0;

      const informativeOptions = [];

        // Frete Fixo R$12.90
        informativeOptions.push({
            id: 'fixed_rate',
            name: 'Frete Fixo',
            price: 12.90,
            delivery_time: null, // Não aplicável ou pode ser um valor fixo
            company: { name: 'Áurea - Envio Padrão', picture: '' }, // Empresa fictícia
            formatted_price: new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(12.90),
            formatted_delivery: '7 à 10 dias úteis'
        });

        // Frete Grátis - acima de R$149.90
         {
            informativeOptions.push({
                id: 'free_shipping',
                name: 'Frete Grátis acima de R$149',
                price: 0,
                delivery_time: null, // Não aplicável
                company: { name: 'Áurea - Envio Padrão', picture: '' }, // Empresa fictícia
                formatted_price: 'GRÁTIS',
                formatted_delivery: '7 à 10 dias úteis'
            });
        }

        // Combinar e reordenar todas as opções (informativas primeiro, depois as calculadas)
        let finalOptions = [...informativeOptions, ...filteredOptions];

        // Se houver opções calculadas, encontrar a mais barata entre elas para o badge
        let cheapestCalculatedOption = null;
        if (filteredOptions.length > 0) {
            cheapestCalculatedOption = filteredOptions.reduce((prev, current) => {
                return (prev.price < current.price) ? prev : current;
            });
        }

        if (!finalOptions || finalOptions.length === 0) {
            this.showError('Nenhuma opção de frete disponível para este CEP');
            return;
        }
        
        let html = '<div class="calculador-frete__options">';
        
        finalOptions.forEach(option => {
            // Marcar a mais barata apenas entre as opções calculadas, se houver
            const isRecommended = cheapestCalculatedOption && option.id === cheapestCalculatedOption.id;
            
            // Formatar preço e prazo de entrega (se já não estiver formatado para Frete Grátis)
            const rawPrice = parseFloat(option.price);
const formattedPrice = option.formatted_price || (isNaN(rawPrice) ? 'R$ --' : new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rawPrice));
            let formattedDelivery = '';
const diasExtras = 3;

if (option.delivery_time && typeof option.delivery_time === 'number') {
    const prazoTotal = option.delivery_time + diasExtras;
    const dataEntrega = adicionarDiasUteis(new Date(), prazoTotal);
    const dataFormatada = formatarDataEntrega(dataEntrega);
    formattedDelivery = `${option.delivery_time} dias úteis — ${dataFormatada}`;
} else if (option.formatted_delivery) {
    const prazoFixo = 10; // para frete fixo e grátis
    const dataEntrega = adicionarDiasUteis(new Date(), prazoFixo);
    const dataFormatada = formatarDataEntrega(dataEntrega);
    formattedDelivery = `${option.formatted_delivery} — ${dataFormatada}`;
} else {
    formattedDelivery = 'Prazo não disponível';
}

            const companyName = option.company && option.company.name ? option.company.name : 'Transportadora';
            const companyLogo = option.company && option.company.picture ? option.company.picture : '';

            html += `
                <div class="calculador-frete__option ${isRecommended ? 'calculador-frete__option--recommended' : ''}">
                    <div class="calculador-frete__option-header">
                        <div class="calculador-frete__option-company">
                            ${companyLogo ? `<img src="${companyLogo}" alt="${companyName}" class="calculador-frete__company-logo">` : ''}
                            <span class="calculador-frete__company-name">${companyName}</span>
                        </div>
                        ${isRecommended ? '<span class="calculador-frete__badge">Correios</span>' : ''}
                    </div>
                    
                    <div class="calculador-frete__option-details">
                        <div class="calculador-frete__option-service">${option.name}</div>
                        <div class="calculador-frete__option-info">
                            <div class="calculador-frete__price">${formattedPrice}</div>
                            <div class="calculador-frete__delivery">${formattedDelivery}</div>
                        </div>
                    </div>
                </div>
            `;
        });
        
        html += '</div>';
        
        // Adicionar informações adicionais (mais barato/mais rápido) apenas para as opções calculadas
        if (filteredOptions.length > 1) { 
            let fastestOption = filteredOptions.reduce((prev, current) => {
                return (prev.delivery_time < current.delivery_time) ? prev : current
            });

           
        }
        
        resultsContainer.innerHTML = html;
        resultsContainer.style.display = 'block';
    }
    
    showLoading(show) {
        const loadingElement = this.container.querySelector('#frete-loading');
        loadingElement.style.display = show ? 'flex' : 'none';
        this.isLoading = show;
    }
    
    showError(message) {
        const errorElement = this.container.querySelector('#frete-error');
        errorElement.innerHTML = `
            <div class="calculador-frete__error-content">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="15" y1="9" x2="9" y2="15"/>
                    <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
                <span>${message}</span>
            </div>
        `;
        errorElement.style.display = 'block';
    }
    
    hideError() {
        const errorElement = this.container.querySelector('#frete-error');
        errorElement.style.display = 'none';
    }
    
    hideResults() {
        const resultsElement = this.container.querySelector('#frete-results');
        resultsElement.style.display = 'none';
    }
    
    recalculate(newProductData) {
        if (newProductData) {
            this.config.productData = newProductData;
        }
        
        const cepInput = this.container.querySelector('#cep-destino');
        if (cepInput.value && this.isValidCEP(cepInput.value)) {
            this.calculate();
        }
    }
}

window.CalculadorFrete = CalculadorFrete;


